import React, { useEffect, useState } from "react";
import logo from "../images/logo.png";
import { Button, Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import styles from "./Navbar.module.css";

function Navibar(props) {
  const [currUrl, setCurrUrl] = useState(global.config.baseUrl);
  useEffect(() => {
    if (window.location.pathname == "/") {
      setCurrUrl("");
    } else {
      setCurrUrl(global.config.baseUrl);
    }
  }, []);
  return (
    <>
      <Navbar
        expand="lg"
        className={props.style == "1" ? styles.navTop : styles.navTopTrs}
      >
        <Container>
          <Navbar.Brand className="me-4">
            <a href={global.config.baseUrl}>
              <img src={logo} width="140" height="28" alt="" />
            </a>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className={styles.navCollapse}>
            <Nav className="me-auto my-2 my-lg-0">
              <Nav.Link className={styles.navLink} href={global.config.baseUrl}>
                Home
              </Nav.Link>
              <Nav.Link className={styles.navLink} href={`${currUrl}/#games`}>
                Game
              </Nav.Link>
              <Nav.Link className={styles.navLink} href={`${currUrl}/#market`}>
                Market
              </Nav.Link>
              <Nav.Link className={styles.navLink} href={`${currUrl}/#events`}>
                Events
              </Nav.Link>
              <Nav.Link className={styles.navLink} href={`${currUrl}/#builds`}>
                Builds
              </Nav.Link>
              <Nav.Link className={styles.navLink} href={`${currUrl}/#map`}>
                Map
              </Nav.Link>
              <Nav.Link className={styles.navLink} href={`${currUrl}/#nft`}>
                NFT's
              </Nav.Link>
              <Nav.Link
                className={styles.navLink}
                href={`${global.config.baseUrl}/market`}
              >
                About
              </Nav.Link>
            </Nav>

            {/* <button className={`btn ${styles.btnGs}`}>Get Started</button> */}
            <a
              href={`${global.config.baseUrl}/LetsPlay`}
              className={`btn ${styles.btnLp}`}
            >
              Let's Play
            </a>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Navibar;
